import type {
  GwsBackupFilter,
  GwsGroup,
  GwsOrgUnit,
} from '@/app/(dashboard)/saas-inventory/google-workspace/backupSettings/backupSettingsTypes';

export const orgUnitsMockData: GwsOrgUnit[] = [
  { id: 'ou-root', name: 'Root', parentId: null, path: '/' },
  { id: 'ou-sales', name: 'Sales', parentId: 'ou-root', path: '/Sales' },
  {
    id: 'ou-sales-east',
    name: 'East',
    parentId: 'ou-sales',
    path: '/Sales/East',
  },
  {
    id: 'ou-sales-west',
    name: 'West',
    parentId: 'ou-sales',
    path: '/Sales/West',
  },
  {
    id: 'ou-eng',
    name: 'Engineering',
    parentId: 'ou-root',
    path: '/Engineering',
  },
  {
    id: 'ou-eng-platform',
    name: 'Platform',
    parentId: 'ou-eng',
    path: '/Engineering/Platform',
  },
  {
    id: 'ou-eng-product',
    name: 'Product',
    parentId: 'ou-eng',
    path: '/Engineering/Product',
  },
  {
    id: 'ou-marketing',
    name: 'Marketing',
    parentId: 'ou-root',
    path: '/Marketing',
  },
  {
    id: 'ou-finance',
    name: 'Finance',
    parentId: 'ou-root',
    path: '/Finance',
  },
];

export const groupsMockData: GwsGroup[] = [
  {
    id: 'g-all',
    name: 'All Staff',
    email: 'all@company.com',
    memberCount: 142,
  },
  {
    id: 'g-eng',
    name: 'Engineering',
    email: 'engineering@company.com',
    memberCount: 38,
  },
  { id: 'g-sales', name: 'Sales', email: 'sales@company.com', memberCount: 24 },
  {
    id: 'g-exec',
    name: 'Executives',
    email: 'executives@company.com',
    memberCount: 6,
  },
  {
    id: 'g-contractors',
    name: 'Contractors',
    email: 'contractors@company.com',
    memberCount: 11,
  },
  {
    id: 'g-interns',
    name: 'Interns',
    email: 'interns@company.com',
    memberCount: 4,
  },
];

const EMPTY_FILTER: GwsBackupFilter = {};

// Module-scoped store keyed by resourceId. Survives dev re-renders but resets on server reload.
const backupSettingsStore = new Map<string, GwsBackupFilter>();

export function getBackupSettings(resourceId: string): GwsBackupFilter {
  return backupSettingsStore.get(resourceId) ?? EMPTY_FILTER;
}

export function setBackupSettings(
  resourceId: string,
  filter: GwsBackupFilter
): void {
  backupSettingsStore.set(resourceId, filter);
}
